import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faPlus,
    faBan,
    faFilter,
    faPercentage,
    faPercent,
    faCog,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Pagination, Modal, } from "react-bootstrap";
import { Trash2 } from "react-feather";
import SweetAlert from "sweetalert2";
import {
    delete_kaizen_category,
    create_kaizen_category,
    get_kaizen_category
} from "../../../api";
import {
    calMaxPage,
} from "../../../common/Functions/CommonFunctions";
import { Tooltip } from "react-tooltip";
import EditKaizenCategory from "./EditKaizenCategory";
// import EditKaizenCategory from "./EditKaizenCategory";

const schema = yup
    .object()
    .shape({
        kaizen_category: yup
            .string()
            .trim()
            .required("Kaizen category is required!"),
    })
    .required();


function KaizenCategory() {
    const [showLabel, setShowLabel] = useState([]);
    const [visible, setVisible] = useState(false);
    const [page, setPage] = useState(1);
    const [srNo, setSrNo] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [dataList, setDataList] = useState({
        data: [],
        loading: true,
        totalRecords: "",
    });
    const [sea_val, setSea_val] = useState(false);
    const [filterConfig, setFilterConfig] = useState({ searchVal: [] });

    const [constLabel, setConstLabel] = useState({});



    const { register, handleSubmit, formState, control, reset, watch } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
    }); // initialise the hook

    let { errors } = formState;

    useEffect(() => {
        const debounceTimeout = setTimeout(() => {
            setPage(1);
            fetchKaizen_Category(page, entriesPerPage);
        }, 1000); // Adjust the delay as needed (e.g., 500 milliseconds)

        return () => {
            clearTimeout(debounceTimeout); // Clear the timeout if searchTerm changes before the timeout expires
        };
    }, [filterConfig]);

    function clearFilter() {
        setFilterConfig({ ...filterConfig, searchVal: [] });
    }

    function fetchKaizen_Category(pg, epp) {
        setDataList({ ...dataList, loading: true, data: [] });

        const payload = {
            pageNo: pg,
            entriesPerPage: epp,
        };

        if (filterConfig.searchVal.length > 0) {
            // payload.productName_list = filterConfig.productName;
            payload.searchVal = filterConfig.searchVal[0];
            if (
                filterConfig.searchVal[0].length > 0 &&
                page !== 1 &&
                sea_val == false
            ) {
                payload.pageNo = 1;
                payload.entriesPerPage = entriesPerPage;

                setPage(1);
                setSrNo(0);
            }
        } else {
            delete payload.searchVal;
        }

        get_kaizen_category(payload).then(
            (res) => {
                setDataList({
                    ...dataList,
                    loading: false,
                    data: res.data.data,
                    totalRecords: res.data.total,
                });
                if (
                    filterConfig.searchVal.length > 0 &&
                    filterConfig.searchVal[0].length > 0
                ) {
                    setSea_val(true);
                } else {
                    setSea_val(false);
                }
                setMaxPage(calMaxPage(res.data.total));
                if (pg == 1) {
                    setSrNo(0);
                    setPage(1);
                }
            },
            (err) => {
                setDataList({ ...dataList, loading: false, data: [] });
            }
        );
    }

    const onSubmit = (data) => {
        if (data !== "") {
            const reqPayload = {
                category_name: data.kaizen_category.trim(),
            };

            create_kaizen_category(reqPayload).then(
                (res) => {
                    if (res.status === 200 || res.status === 201) {
                        toast.success("Kaizen category created successfully !", {
                            autoClose: 3000,
                        });
                        setVisible(false);
                        fetchKaizen_Category(page, entriesPerPage);
                    }
                },
                (err) => {
                    if (err.response.status === 400) {
                        toast.error(err.response.data.message, {
                            autoClose: 2000,
                        });
                        // reset();
                    }
                }
            );
        } else {
            errors.showMessages();
        }
    };


    const deladjustment_reason = (val) => {
        SweetAlert.fire({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this record !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ok",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                // Firing delete api
                const payload = {
                    uuid: val.uuid,
                };
                delete_kaizen_category(payload).then(
                    (res) => {
                        toast.success("Kaizen category deleted successfully !", {
                            autoClose: 3000,
                        });
                        if (dataList.data.length == 1 && page > 1) {
                            fetchKaizen_Category(page - 1, entriesPerPage);
                            setSrNo(parseInt(srNo - entriesPerPage));
                            setPage(1);
                        } else {
                            fetchKaizen_Category(page, entriesPerPage);
                        }
                    },
                    (err) => {
                        toast.error("Something went wrong !", { autoClose: 3000 });
                    }
                );
            }
        });
    };

    function openNav() {
        document.getElementById("mySidebar").style.width = "320px";
        document.getElementById("root_div_main").style.marginLeft = "320px";
        setTimeout(() => {
            document.getElementById("mySidebar").style.overflowX = "visible";
        }, [200]);
    }

    function closeNav() {
        document.getElementById("mySidebar").style.width = "0";
        document.getElementById("root_div_main").style.marginLeft = "0";

        document.getElementById("mySidebar").style.overflowX = "hidden";
    }

    function handleClick(ind) {
        setShowLabel((showLabel) => {
            const updatedCardShow = showLabel.map((val, i) => {
                if (ind === i) {
                    // Toggle the flag for the clicked checkbox
                    return { ...val, flag: !val.flag };
                }
                return val;
            });

            return updatedCardShow;
        });
    }

    return (
        <React.Fragment>
            <ToastContainer />
            {/* Add Item Modal*/}
            <div className="min-vh-100" id="root_div_main">
                <Modal show={visible} onHide={() => setVisible(false)} size={"md"}>
                    <Modal.Header
                        style={{ background: "#2A3643", color: "white" }}
                        closeButton
                    >
                        <Modal.Title>
                            {"Add Kaizen Category"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form action="">
                            <div className="form-group row mt-2">
                                <label
                                    style={{ fontSize: "14px" }}
                                    className="col-form-label col-md-12 bold"
                                >
                                    {"Kaizen Category"}
                                    <span className="text-danger"> *</span>
                                </label>
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        className={
                                            errors.kaizen_category ? "form-control  is-invalid" : "form-control "
                                        }
                                        id="kaizen_category"
                                        name="kaizen_category"
                                        placeholder="Enter kaizen category"
                                        {...register("kaizen_category")}
                                    />
                                    <span className="text-danger err-msg">
                                        {errors.kaizen_category?.message}
                                    </span>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            onClick={handleSubmit(onSubmit)}
                            className="f-16 btn btn-yellow "
                        >
                            {constLabel?.lbl_save ? constLabel.lbl_save : "Save"}
                        </button>
                    </Modal.Footer>
                </Modal>


                <div id="mySidebar" className="customsidebar">
                    <a className="closebtn" onClick={() => closeNav()}>
                        ×
                    </a>

                    <div className=" content">
                        <div>
                            <label
                                className="filterLabel mb-1 bold"
                                style={{ fontSize: "14px" }}
                            >
                                {"Search"}
                            </label>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Search kaizen category"
                                value={
                                    filterConfig.searchVal.length > 0
                                        ? filterConfig.searchVal
                                        : ""
                                }
                                onChange={(val) => {
                                    const inputValue = val.target.value; // Trim leading and trailing whitespaces

                                    if (inputValue.trim() !== "") {
                                        setFilterConfig({
                                            ...filterConfig,
                                            searchVal: [inputValue],
                                        });
                                    } else {
                                        // setFilterConfig({ ...filterConfig, searchVal: [] });
                                    }
                                }}
                            />
                        </div>
                        <div className="my-3 d-flex justify-content-end">
                            <button
                                onClick={() => clearFilter()}
                                className="btn btn-sm btn-yellow "
                            >
                                <FontAwesomeIcon
                                    style={{ color: "#344454" }}
                                    icon={faBan}
                                    size="sm"
                                />{" "}
                                {"Clear Filter"}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="content-wrapper">
                    <div className="d-flex justify-content-between align-items-center">
                        <h1 className="page-heading">{"Kaizen Category"}</h1>
                        <div>
                            <span
                                className="cursor_pointer px-3 me-0 me-md-2"
                                onClick={() => {
                                    openNav();
                                }}
                            >
                                <FontAwesomeIcon
                                    style={{ marginRight: "5px" }}
                                    icon={faFilter}
                                    size="sm"
                                />
                                {"Filter Menu"}
                            </span>


                            <button
                                className="btn btn-pink px-4"
                                onClick={() => {
                                    setVisible(true);
                                    reset();
                                }}
                            >
                                <FontAwesomeIcon
                                    style={{ color: "#fff" }}
                                    icon={faPlus}
                                    size="sm"
                                />{" "}
                                {"Add Kaizen Category"}
                            </button>

                        </div>
                    </div>
                    <div className="card border-0 mt-4">
                        <div className="card-body">
                            <div className="mt-3">
                                {dataList.loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : dataList && dataList.data?.length > 0 ? (
                                    <>
                                        <div className="table-responsive">
                                            <table
                                                className="table table-striped table-sm"
                                                width={"100%"}
                                            >
                                                <thead className="table-grey">
                                                    <tr className="">
                                                        <th scope="col" width="15%">
                                                            {"Sr.No"}
                                                        </th>

                                                        <th scope="col">
                                                            {"Kaizen Category"}
                                                        </th>


                                                        <th scope="col" width="15%">
                                                            {"Action"}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="">
                                                    {dataList.data?.map((val, i) => (
                                                        <tr key={i} className="">
                                                            {/* <td>{val.NCReasonId}</td> */}
                                                            <td>{i + parseInt(srNo) + 1}</td>

                                                            <td >
                                                                {val.category_name != "" && val.category_name !== null
                                                                    ? val.category_name
                                                                    : "NA"}
                                                            </td>

                                                            <td>



                                                                <EditKaizenCategory
                                                                    data={val}
                                                                    constLabel={constLabel}
                                                                    fetchKaizenCategoryList={fetchKaizen_Category}
                                                                    page={page}
                                                                    entriesPerPage={entriesPerPage}
                                                                />


                                                                <>
                                                                    <Tooltip
                                                                        id={"delete-tooltip" + i}
                                                                        place="top"
                                                                    />
                                                                    <div
                                                                        data-tooltip-id={"delete-tooltip" + i}
                                                                        data-tooltip-content={"Delete Kaizen Category"
                                                                        }
                                                                        className="deleteIcon me-2"
                                                                        onClick={() => deladjustment_reason(val)}
                                                                    >
                                                                        <Trash2 color="#FFFFFF" size={18} />
                                                                    </div>
                                                                </>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                            <p className="mb-0">{`Showing ${parseInt(srNo) + 1
                                                } to ${Math.min(
                                                    parseInt(entriesPerPage) + parseInt(srNo),
                                                    dataList.totalRecords
                                                )} of ${dataList.totalRecords} entries`}</p>
                                            <Pagination>
                                                <Pagination.Prev
                                                    disabled={page === 1 ? true : false}
                                                    onClick={() => {
                                                        fetchKaizen_Category(
                                                            page - 1,
                                                            entriesPerPage,
                                                            parseInt(srNo) - parseInt(entriesPerPage)
                                                        );
                                                        setSrNo((prevC) =>
                                                            page - 1 == 1
                                                                ? 0
                                                                : prevC - parseInt(entriesPerPage)
                                                        );
                                                        setPage(page - 1);
                                                    }}
                                                >
                                                    {"Prev"}
                                                </Pagination.Prev>

                                                <Pagination.Item active>{page}</Pagination.Item>

                                                <Pagination.Next
                                                    disabled={
                                                        page === maxPage ||
                                                            maxPage === 0 ||
                                                            entriesPerPage > dataList.data.length
                                                            ? true
                                                            : false
                                                    }
                                                    onClick={() => {
                                                        fetchKaizen_Category(
                                                            page + 1,
                                                            entriesPerPage,
                                                            parseInt(srNo) + parseInt(entriesPerPage)
                                                        );
                                                        setSrNo(
                                                            (prevC) => prevC + parseInt(entriesPerPage)
                                                        );
                                                        setPage(page + 1);
                                                    }}
                                                >
                                                    {"Next"}
                                                </Pagination.Next>
                                            </Pagination>
                                        </div>
                                    </>
                                ) : (
                                    <p className="text-danger mb-0 f-22 text-center mt-4">
                                        {"Kaizen category not found !"}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default KaizenCategory;
